module.exports = __webpack_public_path__ + "img/junaid.0e850e73.jpg";